import { Component, OnInit, Renderer2 } from "@angular/core";

import {
  TagManagerService,
  EventService,
  ThemeService,
  KeyboardService,
  KeyCodes,
  AppointmentService,
} from "../core-ui/services";
import { LocaleService } from "./services/locale.service";
import { NavigationEnd, Router } from "@angular/router";
import { filter, take } from "rxjs";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  constructor(
    gtmService: TagManagerService,
    eventService: EventService,
    localization: LocaleService,
    renderer: Renderer2,
    theme: ThemeService,
    private router: Router,
    private appointment: AppointmentService,
    private keyboard: KeyboardService
  ) {
    eventService.start();
    localization.init();

    // Google Tag Manager setup
    gtmService.trackPages();

    // cannot inject renderer to service
    theme.setRenderer(renderer);
  }

  ngOnInit() {
    this.keyboard.listen(KeyCodes.Enter, this.onEnterKey);
    this.keyboard.listen(KeyCodes.NumpadEnter, this.onEnterKey);

    // we want to run after the guards are done
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        take(1)
      )
      .subscribe(() => {
        this.appointment.listenForEndedInteractions();
      });
  }

  private onEnterKey = () => {
    if (
      document.activeElement &&
      document.activeElement.hasAttribute("tabindex") &&
      document.activeElement.tagName === "AV-MENU-ITEM"
    ) {
      document.activeElement.dispatchEvent(new MouseEvent("click"));
    }
  };
}
